import Marquee from "react-fast-marquee";

const SPONSORS = [
  "AURUM ENERGY",
  "REIGN GG",
  "GOLDPATH STUDIOS",
  "VANGUARD CHIPSETS",
  "OBSIDIAN AUDIO",
  "MERIDIAN ARENA",
  "CROWN BANK",
  "NORTHFORGE",
];

export default function Sponsors() {
  return (
    <section
      data-testid="sponsors-section"
      className="relative py-16 bg-[#080604] border-y border-[#D4AF37]/15"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <p className="text-center text-[10px] font-bold uppercase tracking-[0.4em] text-[#D4AF37] mb-8">
          ⌁ Backed by Champions
        </p>
        <div className="fade-edges">
          <Marquee gradient={false} speed={40} pauseOnHover>
            {SPONSORS.concat(SPONSORS).map((s, i) => (
              <div
                key={i}
                data-testid={`sponsor-${i}`}
                className="mx-10 font-display text-xl lg:text-2xl font-bold uppercase tracking-[0.2em] text-zinc-500 hover:text-[#D4AF37] transition-colors"
              >
                {s}
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
